export const EVENT_TOAST_MESSAGE = "EVENT_TOAST_MESSAGE";
export const EVENT_ERROR_TOAST_MESSAGE = "EVENT_ERROR_TOAST_MESSAGE";
export const EVENT_WARNING_TOAST_MESSAGE = "EVENT_WARNING_TOAST_MESSAGE";

// store
export const EVENT_UPDATED_USER_TIME_ZONE = "EVENT_UPDATED_USER_TIME_ZONE";
export const EVENT_GOOGLE_ANALYTICS_INFO = "EVENT_GOOGLE_ANALYTICS_INFO";

export const EVENT_EXPORT_PROGRAM_CSV_COMPLETED =
  "EVENT_EXPORT_PROGRAM_CSV_COMPLETED";



// WEBPACK FOOTER //
// ./src/store/events.js